export default "__VITE_ASSET__Cq4OVT$A__"